import { apiRequest } from './api';

/**
 * One building's own listings — its sell listings and buy interests.
 *
 * Every building surface used to read these out of `GET /comments`, which
 * merges them into the discussion feed: the URL named comments while the
 * payload carried the building's buyers, and a screen that needed the buyers
 * had to know that. The single-listing view did not, and showed a building's
 * seven buyers as none (JAA-347).
 *
 * Rows are anonymized server-side — no creator id, only a `verified` flag — and
 * carry `isUserOwnEvent` for a signed-in caller, which is what stops someone
 * contacting their own listing.
 *
 * Returns null when the request failed or was aborted, which an empty list
 * cannot express: a building with no listings is ordinary, while a dropped
 * request must leave a surface showing the rows it already had.
 */
export const getBuildingListings = async (
  buildingId: string,
  options: { signal?: AbortSignal } = {},
): Promise<any[] | null> => {
  try {
    const data = await apiRequest(`/buildings/${buildingId}/listings`, {
      signal: options.signal,
    });
    return Array.isArray(data?.listings) ? data.listings : [];
  } catch {
    return null;
  }
};
